import { Box } from "@mui/material";
import { ReactElement } from "react";

interface filePickerInterface {
  handleFilePicked: (file: File) => void;
  layout: ReactElement;
  acceptType: string;
}

export function FilePicker(props: filePickerInterface) {
  function handleChange(e: any) {
    props.handleFilePicked(e.target.files[0]);
    e.target.value = "";
  }

  const randomId = Math.random().toString();

  return (
    <Box width={"100%"}>
      <label htmlFor={randomId}>{props.layout}</label>
      <input
        id={randomId}
        type="file"
        onChange={handleChange}
        accept={props.acceptType}
        style={{ display: "none" }}
      />
    </Box>
  );
}
